import { Component } from 'preact'

import { Caption, TextNode } from '../../textNodes'
import SubscriptionPricing from '../../subscriptionPricing/subscriptionPricing'

export default class NewPaybarPricingVacancy extends Component {
  get captionText() {
    return I18n.t('newPaybar.pricingInfo.vacancy.self')
  }

  render() {
    return (
      <div className="newPaybarPricing">
        <SubscriptionPricing prices={ this.props.prices } smallUnits hasCompactUnitsView />

        { this.captionText &&
          <TextNode
            className="newPaybarPricing-info module device device__mobile"
            html={ this.captionText } />
        }

        { this.captionText &&
          <Caption
            className="newPaybarPricing-info module device device__desktop device__laptop"
            html={ this.captionText } />
        }
      </div>
    )
  }
}
